module.exports = __webpack_public_path__ + "img/tacos.6a04e4be.svg";